/**
 * Título sugerido para kit: "Kit <N> Unidades <título do produto>", cabendo no limite do canal
 * (Mercado Livre: 60 caracteres). Para caber, na ordem: tira o que está entre parênteses, abrevia palavras
 * longas comuns, encurta o prefixo e, por fim, corta na última palavra inteira.
 */
const ABBREVIATIONS: [RegExp, string][] = [
  [/\bcomprimidos?\b/gi, 'Comp'],
  [/\bc[áa]psulas?\b/gi, 'Cáps'],
  [/\bunidades?\b/gi, 'Un'],
  [/\bmililitros?\b/gi, 'ml'],
  [/\bmiligramas?\b/gi, 'mg'],
  [/\bgramas?\b/gi, 'g'],
  [/\brevestidos?\b/gi, 'Rev'],
  [/\befervescentes?\b/gi, 'Efer'],
  [/\bsolu[çc][ãa]o\b/gi, 'Sol'],
  [/\bsuspens[ãa]o\b/gi, 'Susp'],
  [/\bpediátric[oa]s?\b/gi, 'Ped'],
  [/\bembalagem\b/gi, 'Emb'],
  [/\bcaixas?\b/gi, 'Cx'],
  [/\bpacotes?\b/gi, 'Pct'],
];

const squash = (s: string) => s.replace(/\s+/g, ' ').trim();

function cutAtWord(s: string, max: number): string {
  if (s.length <= max) return s;
  const cut = s.slice(0, max + 1);
  const i = cut.lastIndexOf(' ');
  return (i > max * 0.6 ? cut.slice(0, i) : s.slice(0, max)).replace(/[\s,.;:\-–]+$/, '');
}

export function kitTitle(baseTitle: string | null | undefined, units: number, max = 60): string {
  let base = squash(String(baseTitle ?? '').replace(/^kit\s+\d+\s*(un\.?|unidades?)?\s*/i, ''));
  const prefixes = [`Kit ${units} Unidades`, `Kit ${units} Un`, `Kit ${units}x`];
  const fits = (p: string, b: string) => `${p} ${b}`.length <= max;
  if (fits(prefixes[0]!, base)) return squash(`${prefixes[0]} ${base}`);
  base = squash(base.replace(/\([^)]*\)/g, ''));
  if (fits(prefixes[0]!, base)) return squash(`${prefixes[0]} ${base}`);
  for (const [re, short] of ABBREVIATIONS) base = squash(base.replace(re, short));
  for (const p of prefixes) if (fits(p, base)) return squash(`${p} ${base}`);
  const p = prefixes.at(-1)!;
  return squash(`${p} ${cutAtWord(base, max - p.length - 1)}`);
}
